import { render, staticRenderFns } from "./ShopsMonthly.vue?vue&type=template&id=d98e9656&"
import script from "./ShopsMonthly.vue?vue&type=script&lang=ts&"
export * from "./ShopsMonthly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports